export const LABEL_STATUS = 'status';
export const LABEL_HOSTNAME = 'hostname';
export const LABEL_TRANSACTION = 'rum_transaction_name';
export const LABEL_APP_VERSION = 'app_version';
export const LABEL_CONFIG_BUCKET = 'config_bucket';
export const LABEL_RESPONSE_STATUS = 'response_status';
export const LABEL_DEPLOY_TIME = 'deploy_time';
export const LABEL_GIT_REVISION = 'git_revision';
export const LABEL_MONITORING_GROUP = 'monitoring_group';

export const LABEL_VALUE_UNKNOWN = 'unknown';
export const LABEL_VALUE_SUCCESS = 'success';
export const LABEL_VALUE_ERROR = 'error';

export const LABEL_VALUE_MONITORING_GROUP_CHECKOUT = 'checkout';
export const LABEL_VALUE_MONITORING_GROUP_PDP = 'pdp';
export const LABEL_VALUE_MONITORING_GROUP_SB = 'searchbrowsebuy';
export const LABEL_VALUE_MONITORING_GROUP_HOMEPAGE = 'homepage';
export const LABEL_VALUE_MONITORING_GROUP_MC = 'messagecenter';

export const LABEL_LATENCY_THRESHOLD_SECS = 'latency_threshold_secs' as const;
export const LABEL_APDEX_TYPE = 'apdex_type' as const;
export const APDEX_SATISFIED = 'satisfied' as const;
export const APDEX_TOLERATING = 'tolerating' as const;
export type APDEX_THRESHOLDS = typeof APDEX_SATISFIED | typeof APDEX_TOLERATING;
export const APDEX_TYPE = {
    SATISFIED: APDEX_SATISFIED,
    TOLERATING: APDEX_TOLERATING,
} as const;
export const isApdexType = (v: string): v is typeof APDEX_TYPE[keyof typeof APDEX_TYPE] =>
    Object.values(APDEX_TYPE).includes(v as APDEX_THRESHOLDS);

/**
 * We're VERY strict with monitoring group names. No one is
 * allowed to add one without consulting engineering
 * leadership first.
 */
export const VALID_LABEL_VALUES_MONITORING_GROUP = [
    LABEL_VALUE_MONITORING_GROUP_CHECKOUT,
    LABEL_VALUE_MONITORING_GROUP_PDP,
    LABEL_VALUE_MONITORING_GROUP_SB,
    LABEL_VALUE_MONITORING_GROUP_HOMEPAGE,
    LABEL_VALUE_MONITORING_GROUP_MC,
    LABEL_VALUE_UNKNOWN,
] as const;

export type VALID_MONITORING_GROUP_VALUES = typeof VALID_LABEL_VALUES_MONITORING_GROUP[number];

export const isValidMonitoringGroup = (v: string | undefined): v is VALID_MONITORING_GROUP_VALUES =>
    typeof v === 'string' &&
    VALID_LABEL_VALUES_MONITORING_GROUP.includes(v as VALID_MONITORING_GROUP_VALUES);
